import { types } from './movimentoestoque.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'movimentoEstoque',
  columns: [],
  showHideColumns: [
    {
      label: 'ID',
      value: {
        field: 'oid',
        header: 'ID',
        columnKey: 'oid',
        columnSortField: 'oid',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Data',
      value: {
        field: 'dataMovimento',
        header: 'Data',
        columnKey: 'dataMovimento',
        sortable: true,
        filter: true,
        columnSortField: 'dataMovimento',
        fieldFormatter: 'formatarDataHora',
        visible: true,
      },
    },
    {
      label: 'Unidade',
      value: {
        field: 'unidade_sigla',
        columnKey: 'unidade.sigla',
        sortable: true,
        header: 'Unidade',
        filter: true,
        columnSortField: 'unidade.sigla',
        relacionamento: ['unidade'],
        fieldJoin: 'sigla',
        visible: true,
      },
    },
    {
      label: 'Produto',
      value: {
        field: 'produto_descricao',
        header: 'Produto',
        columnKey: 'produto',
        columnSortField: 'produto.descricao',
        relacionamento: ['produto'],
        fieldJoin: 'descricao',
        visible: true,
        sortable: true,
        filter: true,
      },
    },
    {
      label: 'Código',
      value: {
        field: 'produto_oid',
        header: 'Código',
        columnKey: 'produto',
        columnSortField: 'produto.oid',
        relacionamento: ['produto'],
        fieldJoin: 'oid',
        visible: true,
        sortable: true,
        filter: true,
      },
    },
    {
      label: 'Lançamento',
      value: {
        field: 'lancamentoFinanceiro_oid',
        header: 'Lançamento',
        columnKey: 'lancamentoFinanceiro',
        columnSortField: 'lancamentoFinanceiro.oid',
        relacionamento: ['lancamentoFinanceiro'],
        fieldJoin: 'oid',
        visible: true,
        sortable: true,
        filter: true,
      },
    },
    {
      label: 'Nota Entrada',
      value: {
        field: 'notaEntrada_oid',
        header: 'Nota Entrada',
        columnKey: 'notaEntrada',
        columnSortField: 'notaEntrada.oid',
        relacionamento: ['notaEntrada'],
        fieldJoin: 'oid',
        visible: true,
        sortable: true,
        filter: true,
      },
    },
    {
      label: 'Quantidade',
      value: {
        field: 'quantidade',
        header: 'Quantidade',
        columnKey: 'quantidade',
        sortable: true,
        filter: true,
        columnSortField: 'quantidade',
        visible: true,
      },
    },
    {
      label: 'Tipo Movimento',
      value: {
        field: 'tipoMovimentoEstoque',
        header: 'Tipo Movimento',
        columnKey: 'tipoMovimentoEstoque',
        sortable: true,
        filter: true,
        columnSortField: 'tipoMovimentoEstoque',
        fieldFormatter: 'getValue',
        visible: true,
      },
    },
  ],
  currentRecord: {
    tipo: 'inventario',
    unidadeOrigem: '',
    unidadeDestino: '',
  },
  item: {
    produto: '',
    quantidade: 0,
  },
  itens: [],
  saldoEstoque: '',
  unidades: [],
  messages: null,
  selectedFilters: [],
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDMovimentoEstoqueReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('movimentoestoque')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    case types.ADD_ITEM:
      return addItem(state, action)
    case types.SET_ITEM:
      return setItem(state, action)
    case types.ON_CLICK_REMOVE_ITEM:
      return onClickRemoveItem(state, action)
    case types.SET_SALDO_ESTOQUE:
      return setSaldoEstoque(state, action)
    case types.SET_UNIDADES:
      return setUnidades(state, action)
    default:
      return state
  }
}

function reset(state, action) {
  return {
    ...state,
    currentRecord: initialState.currentRecord,
    itens: [],
    saldoEstoque: '',
  }
}

function addItem(state, action) {
  const itens = state.itens || []
  action.payload.hash = new Date().getTime()
  action.payload.unidadeOrigem = state.currentRecord.unidadeOrigem
  action.payload.unidadeDestino = state.currentRecord.unidadeDestino
  itens.push(action.payload)
  return Object.assign({}, state, {
    item: {
      produto: '',
      quantidade: '',
    },
    itens,
    saldoEstoque: '',
  })
}

function setItem(state, action) {
  const item = state.item || {}
  item[action.prop] = action.value
  return Object.assign({}, state, { item })
}

function onClickRemoveItem(state, action) {
  const newItens = state.itens.filter((i) => i.hash !== action.payload.hash)
  return Object.assign({}, state, { itens: newItens })
}

function setSaldoEstoque(state, action) {
  return Object.assign({}, state, { saldoEstoque: action.payload })
}

function setUnidades(state, action) {
  return Object.assign({}, state, { unidades: action.payload })
}
